/**
 * 页头（iOS 大标题）。
 *
 * 大标题放在**滚动内容里**，所以它天然会随滚动离场；
 * 顶部玻璃栏里那个紧缩标题由 motion 里的 useLargeTitle 交叉淡入。
 * 这样比"用 JS 把大标题钉住再缩"简单得多，也更接近系统实际行为。
 *
 * `data-large-title` 是给滚动联动用的锚点，不要删。
 */

import type { ReactNode } from 'react';

export interface PageHeaderProps {
	title: string;
	subtitle?: ReactNode;
	/** 右侧操作，通常是一个 IconButton */
	trailing?: ReactNode;
}

export function PageHeader({ title, subtitle, trailing }: PageHeaderProps): JSX.Element {
	return (
		<header className="flex items-start justify-between gap-3 px-5 pb-4 pt-1">
			<div className="min-w-0">
				<h1
					data-large-title
					className="text-[34px] font-semibold leading-[1.14] tracking-[-0.02em] text-label"
				>
					{title}
				</h1>
				{subtitle ? <div className="mt-1.5 text-[13px] text-label-2">{subtitle}</div> : null}
			</div>
			{trailing ? <div className="mt-2 shrink-0">{trailing}</div> : null}
		</header>
	);
}
